"use strict";
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.LayoutTwoColumns = void 0;
var tslib_1 = require("tslib");
var React = tslib_1.__importStar(require("react"));
var iconTypes_1 = require("../../iconTypes");
var svgIconContainer_1 = require("../../svgIconContainer");
exports.LayoutTwoColumns = React.forwardRef(function (props, ref) {
    var isLarge = props.size >= iconTypes_1.IconSize.LARGE;
    var pixelGridSize = isLarge ? iconTypes_1.IconSize.LARGE : iconTypes_1.IconSize.STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = { transformOrigin: "center" };
    return (React.createElement(svgIconContainer_1.SVGIconContainer, tslib_1.__assign({ iconName: "layout-two-columns", ref: ref }, props),
        React.createElement("path", { d: isLarge ? "M0 380C0 391.04568 8.9543 400 20 400H160C171.0456 400 180 391.0457 180 380V20C180 8.954 171.0456 0 160 0H20C8.9543 0 0 8.954 0 20V380zM220 380C220 391.04568 228.954 400 240 400H380C391.046 400 400 391.0457 400 380V20C400 8.954 391.046 0 380 0H240C228.954 0 220 8.954 220 20V380z" : "M180 300C180 311.0457 188.9544 320 200 320H300C311.046 320 320 311.0457 320 300V20C320 8.954 311.046 0 300 0H200C188.9544 0 180 8.954 180 20V300zM0 300C0 311.0457 8.9543 320 20 320H120C131.0456 320 140 311.0457 140 300V20C140 8.954 131.0456 0 120 0H20C8.9543 0 0 8.954 0 20V300z", fillRule: "evenodd", transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"), style: style })));
});
exports.LayoutTwoColumns.defaultProps = {
    size: iconTypes_1.IconSize.STANDARD,
};
exports.LayoutTwoColumns.displayName = "Blueprint5.Icon.LayoutTwoColumns";
exports.default = exports.LayoutTwoColumns;
//# sourceMappingURL=layout-two-columns.js.map